import { render, staticRenderFns } from "./ProblemToast.vue?vue&type=template&id=46523510&scoped=true"
import script from "./ProblemToast.vue?vue&type=script&setup=true&lang=js"
export * from "./ProblemToast.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ProblemToast.vue?vue&type=style&index=0&id=46523510&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../admin/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46523510",
  null
  
)

export default component.exports